'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/domain/product-item-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import ServiceFeeIncludedTitle from '../../ServiceFeeIncludedTitle'
import DetailedPriceBreakdown from './DetailedPriceBreakdown'

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
}

const BundleFooterPriceBreakdown = ({ bundleSummary, isSellerBusiness, selectedItems }: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const unifiedPriceBreakDownTest = useAbTest('unified_price_breakdown')
  const shouldShowDetailedBreakdown = unifiedPriceBreakDownTest?.variant === 'on'

  if (shouldShowDetailedBreakdown) {
    return (
      <DetailedPriceBreakdown
        bundleSummary={bundleSummary}
        isSellerBusiness={isSellerBusiness}
        selectedItems={selectedItems}
      />
    )
  }

  return (
    <ServiceFeeIncludedTitle
      itemId={selectedItemIds[0]!}
      isSellerBusiness={isSellerBusiness}
      shouldTrimTitle
      shouldMinimiseTitle
      itemPrice={price}
      serviceFee={buyerProtectionFee}
      totalItemPrice={priceWithBuyerProtectionFee}
      trackUnification
    />
  )
}

export default BundleFooterPriceBreakdown
